/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage Increase Calculator`)
};

const es_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Aumento Porcentual`)
};

const de_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner für prozentualen Anstieg`)
};

const nl_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentagestijging berekenen`)
};

const fr_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur d'augmentation en pourcentage`)
};

const it_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di aumento percentuale`)
};

const pt_br2_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Aumento Percentual`)
};

const pt_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Aumento Percentual`)
};

const ja_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント増加計算機`)
};

const zh_pct_increase_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比增长计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_h1", locale)
	if (locale === "en") return en_pct_increase_h1(inputs)
	if (locale === "es") return es_pct_increase_h1(inputs)
	if (locale === "de") return de_pct_increase_h1(inputs)
	if (locale === "nl") return nl_pct_increase_h1(inputs)
	if (locale === "fr") return fr_pct_increase_h1(inputs)
	if (locale === "it") return it_pct_increase_h1(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_h1(inputs)
	if (locale === "pt") return pt_pct_increase_h1(inputs)
	if (locale === "ja") return ja_pct_increase_h1(inputs)
	return zh_pct_increase_h1(inputs)
};